<template>
  <el-form ref="form" :model="curInput" :rules="rules" label-width="100px">
    <option-config :curInput="curInput" :selectConfig="curInput.radio_option"></option-config>
  </el-form>
</template>

<script>
  import optionConfig from './optionConfig'
  export default {
    props: ['curInput'],
    data() {
      return {
      }
    },
    components: {
      optionConfig
    }
  }
</script>


// WEBPACK FOOTER //
// radioConfig.vue?7f8ca879